import { Injectable } from '@angular/core';

@Injectable()
export class ReportUrl {
    public static get GET_REPORT():string{return '/api/Report'}
    public static get GET_CENTRE():string{return '/api/Report/centre'}
    public static get GET_VACCINE():string{return '/api/Report/vaccine'}
    public static get GET_GENDER():string{return '/api/Report/gender'}
    public static get GET_GROUP():string{return '/api/Report/group'}
    public static get GET_AGE_GROUP():string{return '/api/Report/ageGroup'}
    public static get GET_DESTINATION():string{return '/api/Report/destination'}
    public static get GET_COUNTRY():string{return '/api/Report/country'}
    public static get GET_OCCUPATION():string{return '/api/Report/occupation'}
    public static get GET_PRACTITIONER():string{return '/api/Report/practitioner'}
    public static get GET_PRODUCT_CATEGORIES():string{return '/api/Report/productCategories'}
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/report.url.ts